export default class Splash extends Phaser.Group {
  constructor(game, x, y, foodAtlas, foodKey) {
    super(game);

    this.x = x;
    this.y = y;

    // Splash
    this.splash = this.game.make.image(0, 0, 'foodgame_elements', 'splash.png');
    this.splash.anchor.set(0.5);

    // food
    this.food = this.game.make.image(0, 0, foodAtlas, foodKey);
    this.food.anchor.set(0.5);
    this.food.angle = -30;
    this.food.scale.set(0.75);

    //
    this.addChild(this.splash);
    this.addChild(this.food);

    //
    this.game.add
      .tween(this)
      .to({ y: 720 }, 800, Phaser.Easing.Quadratic.In, true)
      .onComplete.add(this.destroy, this);

    //
    this.game.sounds.playSpriteSFX('splash', { spriteID: 'game_audiosprite' });
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/Splash.js